<template>
  <b-modal
    ref="returnsModal"
    title="Add Returns Back to Stock"
    no-close-on-backdrop
    hide-footer
    size="lg"
    @shown="shown"
    @hidden="clear"
  >
    <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
    <form @submit.prevent="scanItem">
      <div class="form-group form-group-lg">
        <label for="model">Scan item model here</label>
        <input
          ref="model"
          type="text"
          class="form-control text-uppercase"
          id="model"
          placeholder="item model"
          name="model"
          v-model="scanModel"
          autofocus
        />
      </div>
      <button
        type="submit"
        class="btn btn-light"
        style="display:none;"
      ></button>
    </form>

    <table class="table table-striped table-bordered" v-if="items.length > 0">
      <thead>
        <tr>
          <th style="width: 25%;">Qty</th>
          <th>Model</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) of $v.items.$each.$iter" :key="index">
          <td>
            <div class="form-group mb-0">
              <input
                :class="{
                  'is-invalid': item.returnQty.$invalid,
                  'is-valid': !item.returnQty.$invalid
                }"
                class="form-control form-control-sm text-center"
                v-model.trim="item.returnQty.$model"
              />
              <div class="invalid-feedback" v-if="!item.returnQty.$required">
                Invalid Qty!
              </div>
            </div>
          </td>
          <td>{{ item.model.$model + " (" + item.name.$model + ")" }}</td>
        </tr>
      </tbody>
    </table>

    <div>
      <button
        class="btn btn-success mt-5 float-right text-white"
        :disabled="items.length == 0 || $v.$invalid"
        @click="updateStock"
      >
        Update Stock
      </button>
      <button
        class="btn btn-secondary mt-5 float-right text-white mr-2"
        @click="hideModal"
      >
        Cancel
      </button>
    </div>
  </b-modal>
</template>

<script>
import { required, numeric, minValue } from "vuelidate/lib/validators";
export default {
  name: "returns-modal",
  data() {
    return {
      scanModel: null,
      items: [],
      error: null
    };
  },
  validations: {
    items: {
      required,
      $each: {
        returnQty: {
          required,
          numeric,
          minValue: minValue(1)
        },
        model: {
          required
        },
        name: {
          required
        }
      }
    }
  },
  methods: {
    scanItem() {
      this.error = null;
      this.$http
        .get(
          this.APIURL +
            this.BRAND +
            "/stock-exist?model=" +
            this.scanModel +
            "&qty=0"
        )
        .then(
          response => {
            let data = response.data;
            if (data.status == "success") {
              data.item.returnQty = 1;
              this.items.push(data.item);
              this.scanModel = null;
            } else if (data.status == "not-found") {
              //if no then display a modal popup with error and just a dismiss button
              this.error = "The scanned item doesn't exist in stock.";
            }
            this.scanModel = null;
            this.$refs.model.focus();
          },
          error => {
            console.log(error);
          }
        );
    },
    changeValue(index, value) {
      this.items[index].returnQty = value;
    },
    updateStock() {
      if (!this.$v.$invalid) {
        let items = this.items;
        this.hideModal();
        let loader = this.$loading.show();
        this.$http
          .post(this.APIURL + this.BRAND + "/stock-returns", { items: items })
          .then(
            response => {
              this.$swal({
                title: "Success!",
                showConfirmButton: false,
                timer: 1000,
                html: "Stock updated successfully!",
                type: "success",
                onClose: () => {
                  location.reload();
                }
              });
            },
            error => {
              console.log(error);
            }
          );
      }
    },
    showModal() {
      this.$refs.returnsModal.show();
    },
    hideModal() {
      this.$refs.returnsModal.hide();
    },
    shown() {
      this.$refs.model.focus();
    },
    clear() {
      this.scanModel = null;
      this.items = [];
      this.error = null;
    }
  }
};
</script>
<style></style>
